export default __webpack_public_path__ + "static/media/icon-alert-success.52215fc6.svg";